import React from "react";
export const CurrentLanguage = React.createContext(`en`);
